import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ViewBasePage } from '@shared/pages';
import { AccountProfileService, DealershipService, EventsService, FirebaseFunctionsService, UtilsService, 
    UxHelperService, FirestorePathsService  } from '@shared/services';
import { Constants, type TAccountProfile } from '@shared/models';

@Component({
    'selector': 'app-rewardFunnelTests',
    'templateUrl': './rewardFunnelTests.page.html',
    'styleUrls': ['./rewardFunnelTests.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class RewardFunnelTestsPage extends ViewBasePage implements OnInit {
    public vm: any = {};

    constructor(private accountProfileService: AccountProfileService, private firestorePathsService: FirestorePathsService,
        injector: Injector) {
        super(injector);
    }

    public async onReset1Click() {
        try {
            // await this.uxHelperService.showSpinner('Resetting Signup and Expiration Dates.');
            await this.resetSignupAndExpirationsDate(30);
            
            // await this.uxHelperService.hideSpinner();
            await this.uxHelperService.showToast('Check Message Center for a new message.');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public async onReset2Click() {
        try {
            await this.uxHelperService.showSpinner('Resetting Signup and Expiration Dates.');

            this.resetSignupAndExpirationsDate(7);
            await this.uxHelperService.hideSpinner();
            await this.uxHelperService.showToast('Check Message Center for a new message.');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public async onReset3Click() {
        try {
            await this.uxHelperService.showSpinner('Resetting Signup and Expiration Dates.');

            this.resetSignupAndExpirationsDate(3);
            await this.uxHelperService.hideSpinner();
            await this.uxHelperService.showToast('Check Message Center for a new message.');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public async onReset4Click() {
        try {
            await this.uxHelperService.showSpinner('Resetting Signup and Expiration Dates.');

            this.resetSignupAndExpirationsDate(0);
            await this.uxHelperService.hideSpinner();
            await this.uxHelperService.showToast('Check Message Center for a new message.');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    private async resetSignupAndExpirationsDate(daysBeforeExpirationDate: number): Promise<void> {
        const accountProfile = await this.getCypressAccountProfile();
        
        const today = this.dateService.addToNow(-daysBeforeExpirationDate, 'days');
        const signupDate = this.dateService.addToNow(-30 + daysBeforeExpirationDate, 'days'); 
        const expirationDate = this.dateService.addToNow(daysBeforeExpirationDate, 'days');

        accountProfile.signupDate = signupDate;
        accountProfile.periodInfo.expirationDate = expirationDate;

        await this.accountProfileService.update(accountProfile);
    }

    private async getCypressAccountProfile(): Promise<TAccountProfile> {
        const accountNumber = '00000-0000-00002';   // Cypress test account number
        this.firestorePathsService.setAccount(accountNumber);

        const accountProfile = await this.accountProfileService.getAccountProfileByAccountNumber(accountNumber);
        return accountProfile;
    }
}
